<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.877"
    height="13.281"
    viewBox="0 0 12.877 13.281">
    <g id="ic-layout-picture-right" transform="translate(-0.25 0.75)">
      <rect
        id="Rectangle_75"
        data-name="Rectangle 75"
        width="4.712"
        height="4.712"
        rx="1"
        transform="translate(1)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <rect
        id="Rectangle_76"
        data-name="Rectangle 76"
        width="4.712"
        height="4.712"
        rx="1"
        transform="translate(1 7.068)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_278"
        data-name="Line 278"
        x1="4.348"
        transform="translate(8.029 8.247)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_279"
        data-name="Line 279"
        x1="2.898"
        transform="translate(8.029 10.603)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_280"
        data-name="Line 280"
        x1="2.898"
        transform="translate(8.029 3.534)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_281"
        data-name="Line 281"
        x1="4.348"
        transform="translate(8.029 1.178)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
    </g>
  </svg>
</template>
